import PrimaryButton from "../../../components/Buttons/primary-button";
import {useNavigate} from "react-router-dom";

export default function TryDemoSection() {
    const navigation = useNavigate();

    return (
        <div
            className="px-[12px] bg-[#F0FBFF] lg:py-[65px] flex justify-center items-center box-border py-[18px] lg:px-[148px]">

            <div className={"flex flex-col lg:flex-row justify-center items-center lg:gap-[61px]  "}>
                <div className={"flex flex-col gap-[48px]"}>
                    <div className={"flex flex-col gap-[12px] lg:gap-[24px]"}>
                        <p className={"font-semibold text-[24px] leading-[120%] lg:text-[48px]"}>
                            Instant <span className={"text-[#0C98FE]"}>Speaking & Writing</span>  Analysis Based on Real DET Scoring Factors
                        </p>
                        <p className={'text-[12px] lg:text-[20px]'}>
                            Our AI evaluates your speaking and writing using the same scoring categories as the real Duolingo English Test. Get clear, personalized insights that show exactly what to improve — in  seconds.
                        </p>


                    </div>

                    <div className={"flex flex-row justify-between"}>
                        <PrimaryButton
                        onClick={() => navigation("/practice")}
                        >
                            Try the Demo
                        </PrimaryButton>


                    </div>
                </div>
                <img
                    src={"/images/laptop.gif"}
                    alt={"laptop-demo-image"}
                    className="w-auto lg:h-[500px]  h-[300px] object-contain"
                />
            </div>
        </div>
    )
}